import { render, staticRenderFns } from "./MoralMallAdmin.vue?vue&type=template&id=31a94f3a&scoped=true"
import script from "./MoralMallAdmin.vue?vue&type=script&lang=js"
export * from "./MoralMallAdmin.vue?vue&type=script&lang=js"
import style0 from "./MoralMallAdmin.vue?vue&type=style&index=0&id=31a94f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a94f3a",
  null
  
)

export default component.exports